<template>
  <div>
    <div class="relative">
      <div class="w-full p-4 flex items-center justify-between">
        <button class="text-gray-700" @click="toggleNavItems">
          <CIcon icon="IconMenu" class="w-6 h-6" />
        </button>
        <img src="../../assets/images/full-logo-dark.png" alt="Momentum Logo" class="h-8">
        <div />
      </div>
      <transition name="fade">
        <div v-if="state.showNavItems" class="absolute left-2 top-2 bg-white border shadow-lg rounded-md w-[90%] sm:w-1/2 transition-all duration-300 ease-in-out" :style="setZIndex(true)">
          <div class="flex justify-end p-2 border-b">
            <CButton type="button" name="textPlainButton" @click="toggleNavItems">
              <CIcon icon="IconXClose" class="w-6 h-6" />
            </CButton>
          </div>
          <ul>
            <li
              v-for="(link, index) in sidebarLinks"
              :key="index"
              class="border-b py-2 px-5 hover:bg-gray-100 transition-all duration-300 ease-in-out"
              :class="{ 'active-route': isActiveRoute(link.activeRoutes) }"
            >
              <router-link :to="{ name: link.routeName }">
                <p v-text="link.title" />
              </router-link>
            </li>
            <li v-for="(option, index) in computedProfileOptions" v-show="computedProfileOptions.length" :key="index" class="border-b py-2 px-5 hover:bg-gray-100 transition-all duration-300 ease-in-out">
              <button type="button" class="w-full text-left" @click="handleOptionClick(option.key as string)">
                <p v-text="option.label" />
              </button>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <PopUpNotifications />
  </div>
</template>

<script lang="ts">
import { DropdownMixedOption } from "naive-ui/lib/dropdown/src/interface";
import { computed, defineComponent, PropType, reactive } from "vue";
import { RouteLocationNormalizedLoaded, useRoute } from "vue-router";

import { setZIndex } from "../../components/library/utilities";
import PopUpNotifications from "../../components/notifications/PopUpNotifications.vue";
import { TSidebarLink } from "../../types/momentum";

export default defineComponent({
  components: {
    PopUpNotifications,
  },
  emits: ["update:profile-option-clicked"],
  props: {
    profileOptions: {
      default: () => [],
      type: Array as PropType<DropdownMixedOption[]>,
    },
    sidebarLinks: {
      default: () => [],
      type: Array as PropType<TSidebarLink[]>,
    },
  },
  setup(props, { emit }) {
    type TState = {
      showNavItems: boolean;
    };

    const route: RouteLocationNormalizedLoaded = useRoute();
    const state: TState = reactive({
      showNavItems: false,
    });

    const computedProfileOptions = computed(() => {
      return props.profileOptions.filter((option) => option.label);
    });

    function toggleNavItems(): void {
      state.showNavItems = !state.showNavItems;
    }

    function handleOptionClick(value: string): void {
      emit("update:profile-option-clicked", value);
    }

    function isActiveRoute(routeNames: string[]): boolean {
      return routeNames?.includes(route.name as string);
    }
    return {
      computedProfileOptions,
      handleOptionClick,
      isActiveRoute,
      setZIndex,
      state,
      toggleNavItems,
    };
  },
});
</script>
